module.exports = __webpack_public_path__ + "img/noData.b61d0046.png";